import { apiV2 } from 'lib/api/v2'

import useSWRMutation from 'swr/mutation'

type UseSendSurveyAnswerMutationRequest = {
  surveyType: Enum.CorporateSurveyType
  response: string
  answeredBy: string
}

async function fetcher(
  _: [string],
  { arg }: { arg: UseSendSurveyAnswerMutationRequest }
) {
  const { data } = await apiV2.post<Model.CorporateSurveyAnswer>(
    `private/surveys`,
    {
      data: arg
    }
  )

  return data
}

export function useSendSurveyAnswerMutation() {
  return useSWRMutation(['sendSurveyAnswer'], fetcher)
}
